const routes = {

    landing: "/",

    auth: {
      login: "login",
      signup: "signup",
      passwordEntry: "password-entry",
      passwordReset: "password-reset",
    },
  
    onboarding: "onboarding",
    
    activity: {
      main: "activity",
      details: "activity/:id",
    },
  
    cases: {
      main: "cases",
      details: "cases/:id",
      search: "cases/search",
    },
  
    account: {
      main: "account",
      editProfile: "account/profile",
      passwordChange: "account/password-change"
    },
  
    privactPolicy: "privacy-policy",
    
    termsOfUse: "terms-and-conditions",

    admin: {
        main: "dashboard",
        logs: "logs",
        workers: "workers",
        users: "users",
        cases: "cases",
        privacyPolicy: "pp",
        settings: "settings",
        termsOfUse: "tac"
    }

}

export default routes;